
export default {
    name: 'InputTextarea',

    // you may use v-model on this component.
    props: {
        id: {
            type: String,
            default: 'input-textarea',
        },
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        rows: {
            type: Number,
            default: 8,
        },
    },
}
